import React, { useState } from 'react'
import { useAuthContext } from './useAuthContext'
import { getBackendUrl } from '../env'
export const useSignup = () => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { dispatch } = useAuthContext()

  const signup = async (email:string, password:string, firstName:string, lastName:string) => {
    setIsLoading(true)
    setError(null)

    const response = await fetch(`${getBackendUrl()}/api/user/signup`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ email, password, firstName, lastName })
    })
    const json = await response.json()

    if (!response.ok) {
      setIsLoading(false)
      setError(json.error)
    }
    if (response.ok) {
      // save the user to local storage
      localStorage.setItem('user', JSON.stringify(json))

      // update the auth context
      dispatch({type: 'LOGIN', payload: json})

      // update loading state
      setIsLoading(false)
    }
  }

  return { signup, isLoading, error }
}